<template>
	<div class="athletes">
		<slot name="header">
			<h2>{{ $I18n.trans_choice('one.athlete', 2) }}</h2>
		</slot>
		<AthleteSelector
			:display-only="true"
			:options="athletes"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AthleteSelector } from '@js/one/components/AthleteSelector';

export default {
	name:       'Athletes',
	components: { AthleteSelector },
	computed:   {
		...mapGetters({
			event:             'event/event',
			eventParticipants: 'event/participants',
		}),
		athletes() {
			return [
				{
					key:   'none',
					label: this.$I18n.trans('one.no_athlete'),
				},
				...this.eventParticipants.map((participant) => ({
					id:    participant.id,
					value: participant,
					key:   `athlete-${participant.id}`,
					label: participant.name,
					image: participant.imageUrl,
				})),
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.athletes {
	padding: 24px;
	display: flex;
	flex-direction: column;

	h2 {
		font-size: 24px;
	}
}
</style>
